/**
 * REM-MOB-03 (full) — public app-config fetch.
 *
 * The backend publishes the minimum supported client version on its PUBLIC, unauthenticated
 * `/health` endpoint (see beam-backend/src/index.ts, field `minSupportedVersion`). The mobile app
 * reads it BEFORE the authenticated surface renders so an out-of-date binary is force-updated with a
 * graceful screen instead of failing loud on the first zod contract-drift error.
 *
 * This is deliberately dependency-light: a bare fetch (no Bearer token — the endpoint is public) so it
 * works even when the session layer / api client are not yet initialized. Never throws for a missing
 * field; a null result means "backend imposes no minimum" and the gate stays open.
 */
import { API_BASE_URL } from '../config';

/** GET /health → the backend-declared minimum supported app version, or null when none is set. */
export async function fetchMinSupportedVersion(): Promise<string | null> {
  const res = await fetch(`${API_BASE_URL}/health`, { headers: { accept: 'application/json' } });
  if (!res.ok) throw new Error(`health ${res.status}`);
  const body = (await res.json()) as { minSupportedVersion?: string | null };
  const v = body.minSupportedVersion;
  return typeof v === 'string' && v.length > 0 ? v : null;
}
